<div style="padding: 25px">
    <h1 mat-dialog-title>{{ "CASHIERMANAGEMENT.deposit" | translate }}</h1>
    <div mat-dialog-content>
        <div class="rounded border p-10">
            <mat-form-field appearance="fill">
                <mat-label>{{ "CASHIERMANAGEMENT.accountsBank" | translate }}</mat-label>
                <mat-select
                    [(ngModel)]="financialAccount"
                    [disabled]="selectedDeposit != null || (_loaderService.isLoading | async)"
                >
                    <mat-option *ngFor="let financialAccount of financialAccounts" [value]="financialAccount">
                        {{
                            financialAccount.companyName +
                                " - " +
                                financialAccount.branchCode +
                                " - " +
                                financialAccount.accountCode
                        }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" [floatLabel]="'auto'">
                <mat-label>{{ "CASHIERMANAGEMENT.depositDate" | translate }}</mat-label>
                <input matInput [matDatepicker]="pickerDepositDate" [formControl]="dateDeposit" />
                <mat-datepicker-toggle matSuffix [for]="pickerDepositDate"></mat-datepicker-toggle>
                <mat-datepicker
                    #pickerDepositDate
                    [disabled]="false || selectedDeposit != null || (_loaderService.isLoading | async)"
                ></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="fill" [floatLabel]="'auto'">
                <mat-label>{{ "CASHIERMANAGEMENT.value" | translate }}</mat-label>
                <input
                    matInput
                    [(ngModel)]="valueDeposit"
                    currencyMask
                    [disabled]="selectedDeposit != null || (_loaderService.isLoading | async)"
                />
            </mat-form-field>

            <button
                mat-raised-button
                color="accent"
                [disabled]="!isValidNewDeposit() || selectedDeposit != null || (_loaderService.isLoading | async)"
                (click)="addDeposit()"
            >
                <mat-icon>add</mat-icon>{{ "CASHIERMANAGEMENT.add" | translate }}
            </button>
        </div>

        <div class="rounded table-dialog border p-10">
            <table mat-table [dataSource]="listCashierManagementDeposit">
                <!-- FinancialAccountId Column -->
                <ng-container matColumnDef="financialAccountId">
                    <th mat-header-cell *matHeaderCellDef>{{ "CASHIERMANAGEMENT.accountBank" | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        <ng-container *ngIf="selectedDeposit !== element; else elseEditFinancialAccount">
                            {{ getFinancialAccountName(element.financialAccountId) }}
                        </ng-container>
                        <ng-template #elseEditFinancialAccount>
                            <mat-form-field appearance="fill">
                                <mat-label>{{ "CASHIERMANAGEMENT.accountsBank" | translate }}</mat-label>
                                <mat-select [(ngModel)]="financialAccountEdit">
                                    <mat-option
                                        *ngFor="let financialAccount of financialAccounts"
                                        [value]="financialAccount"
                                    >
                                        {{
                                            financialAccount.companyName +
                                                " - " +
                                                financialAccount.branchCode +
                                                " - " +
                                                financialAccount.accountCode
                                        }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field></ng-template
                        >
                    </td>
                </ng-container>

                <!-- Date Column -->
                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef>{{ "CASHIERMANAGEMENT.date" | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        <ng-container *ngIf="selectedDeposit !== element; else elseEditDate">
                            {{ element.date | date: "dd/MM/yyyy" }}
                        </ng-container>
                        <ng-template #elseEditDate>
                            <mat-form-field appearance="fill" [floatLabel]="'auto'">
                                <mat-label>{{ "CASHIERMANAGEMENT.depositDate" | translate }}</mat-label>
                                <input matInput [matDatepicker]="pickerDepositDate" [formControl]="dateDepositEdit" />
                                <mat-datepicker-toggle matSuffix [for]="pickerDepositDate"></mat-datepicker-toggle>
                                <mat-datepicker #pickerDepositDate [disabled]="false"></mat-datepicker> </mat-form-field
                        ></ng-template>
                    </td>
                </ng-container>

                <!-- Value Column -->
                <ng-container matColumnDef="value">
                    <th mat-header-cell *matHeaderCellDef>{{ "CASHIERMANAGEMENT.value" | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        <ng-container *ngIf="selectedDeposit !== element; else elseEditValue">
                            {{ element.value | currency }}
                        </ng-container>
                        <ng-template #elseEditValue
                            ><mat-form-field appearance="fill" [floatLabel]="'auto'">
                                <mat-label>{{ "CASHIERMANAGEMENT.value" | translate }}</mat-label>
                                <input matInput [(ngModel)]="valueDepositEdit" currencyMask />
                            </mat-form-field>
                        </ng-template>
                    </td>
                </ng-container>

                <!-- Actions Column -->
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef style="width: 110px"></th>
                    <td mat-cell *matCellDef="let element; let i = index">
                        <div>
                            <ng-container *ngIf="selectedDeposit !== element; else elseEdit">
                                <button
                                    mat-icon-button
                                    color="accent"
                                    (click)="onEditDeposit(element)"
                                    [disabled]="selectedDeposit != null || (_loaderService.isLoading | async)"
                                    style="margin-right: 5px"
                                >
                                    <mat-icon>edit</mat-icon>
                                </button>
                                <button
                                    mat-icon-button
                                    color="warn"
                                    (click)="onDeleteDeposit(i)"
                                    [disabled]="selectedDeposit != null || (_loaderService.isLoading | async)"
                                >
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </ng-container>
                            <ng-template #elseEdit>
                                <button
                                    mat-icon-button
                                    color="accent"
                                    (click)="onSaveEditDeposit(i)"
                                    [disabled]="!isValidEditDeposit() || (_loaderService.isLoading | async)"
                                    style="margin-right: 5px"
                                >
                                    <mat-icon>save</mat-icon>
                                </button>
                                <button
                                    mat-icon-button
                                    color="basic"
                                    (click)="selectedDeposit = null"
                                    [disabled]="_loaderService.isLoading | async"
                                >
                                    <mat-icon>close</mat-icon>
                                </button>
                            </ng-template>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
            <div *ngIf="listCashierManagementDeposit?.length == 0" class="noDeposit">
                {{ "CASHIERMANAGEMENT.thereIsNoDepositAdded" | translate }}
            </div>
        </div>
        <div class="rounded border p-10" style="margin-top: 10px">
            <div style="padding-bottom: 25px">
                <div>
                    {{ "CASHIERMANAGEMENT.amountToDeposit" | translate }}: {{ data.cashier?.toDeposit | currency }}
                </div>
                <div>{{ "CASHIERMANAGEMENT.depositedAmount" | translate }}: {{ getSumDeposit() | currency }}</div>
                <div>
                    {{ "CASHIERMANAGEMENT.missingValue" | translate }}:
                    {{ data.cashier?.toDeposit - getSumDeposit() | currency }}
                </div>
            </div>
        </div>
    </div>
    <div mat-dialog-actions>
        <button mat-raised-button (click)="onCancelDeposit()">{{ "CASHIERMANAGEMENT.cancel" | translate }}</button>
        <button
            mat-raised-button
            color="primary"
            [disabled]="
                listCashierManagementDeposit.length == 0 ||
                selectedDeposit != null ||
                (_loaderService.isLoading | async)
            "
            (click)="onSaveDeposit()"
        >
            {{ "CASHIERMANAGEMENT.deposit2" | translate }}
        </button>
    </div>
</div>
